import { render, staticRenderFns } from "./ForwarderList.vue?vue&type=template&id=72eb3286&scoped=true"
import script from "./ForwarderList.vue?vue&type=script&lang=js"
export * from "./ForwarderList.vue?vue&type=script&lang=js"
import style0 from "./ForwarderList.vue?vue&type=style&index=0&id=72eb3286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb3286",
  null
  
)

export default component.exports